import { useTranslation } from 'react-i18next';
import SwitchActivation from '../../../components/layout/SwitchActivation';
import { editIcon } from '../../../config/variables';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { ILocation } from '../types/interfaces';
import { useNavigate } from 'react-router-dom';
import useFormsIntegrationHelpers from '../../../hooks/useFormsIntegrationHelpers';
import DeleteButton from '../../../components/buttons/DeleteButton';

export default function LocationsTableItem({ item }: { item: ILocation }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const { handleSubmit, submitLoading } = useFormsIntegrationHelpers({
    id: item.id,
    editApi: `/admin/locations/${item.id}`,
    itemName: t('location'),
    queryKey: ['locations']
  });

  function changeHiddenHandle(value: boolean) {
    handleSubmit({
      ...item,
      service_center: item?.service_center ? 1 : 0,
      parts: item?.parts ? 1 : 0,
      quick_service: item?.quick_service ? 1 : 0,
      showroom: item?.showroom ? 1 : 0,
      workshop: item?.workshop ? 1 : 0,
      bodyshop: item?.bodyshop ? 1 : 0,
      hidden: value ? 1 : 0,
      images: item?.media?.map((item: any) => item?.url) || [],
      meida: null,
      city_id: item?.city?.id,
      image_orders: item?.media?.map((_, index: number) => index),
      _method: 'PUT'
    });
  }

  const hasEditPermission = hasPermission(['locations.edit'])

  return (
    <div
      className={`item has_logo locations ${hasEditPermission && "clickable"}`}
      key={item.id}
      onClick={(e) => {
        hasEditPermission && navigateRoute(e, `/locations/create-location/${item.id}`, navigate);
      }}
    >
      <div className="column">
        <div className="capitalize">{item?.name?.[i18n?.language as 'en' | 'ar'] || '-'}</div>
      </div>
      <div className="column">
        <div className="capitalize">{item?.service_center ? t('yes') : t('no')}</div>
      </div>
      <div className="column">
        <SwitchActivation
          onChange={(e: any) => {
            changeHiddenHandle(e?.target?.checked);
          }}
          loading={submitLoading}
          active={item.hidden}
        />
      </div>
      {hasPermission(['locations.edit']) && (
        <div className="column actions actions_col">
          <div
            className="action_btn edit"
            onClick={(e) => {
              navigateRoute(e, `/locations/create-location/${item.id}`, navigate);
            }}
          >
            {editIcon}
          </div>
          <DeleteButton deleteRoute={`/admin/locations`} queryKey='locations' id={Number(item.id)}/>
        </div>
      )}
    </div>
  );
}
